##
# Return bool `true` if `input` is one of `"true"`, `true`,`"1"` or `1`
# Everything else will return false
##
angular
	.module 'App.Value'
	.value 'parseBool', (input) ->
		return input == 'true' or input == true or input == '1' or input == 1
